// src/components/ui/calendar/core/CalendarTimeSlot/CalendarTimeSlot.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const CalendarTimeSlot = ({
  date,
  hour,
  isAvailable = false,
  isClickable = false,
  availabilityColor = 'rgba(139, 92, 246, 0.1)',
  availabilityBorder = '#8B5CF6',
  onClick,
  children,
  className = '',
  height = 'h-16' // 'h-12', 'h-16', 'h-20', etc.
}) => {
  const handleClick = () => {
    if (isClickable && onClick) {
      onClick(date, hour);
    }
  };

  return (
    <div
      className={cn(
        // Base time slot styling (matching your current implementation)
        "relative border-r border-slate-600/30 last:border-r-0 group",
        "hover:bg-slate-700/10 transition-colors duration-200",
        height,
        
        // Clickable states
        isClickable && "cursor-pointer",
        
        className
      )}
      onClick={handleClick}
    >
      {/* Background availability overlay (matching your partner availability) */}
      {isAvailable && (
        <div 
          className="absolute inset-0 pointer-events-none rounded-sm"
          style={{
            backgroundColor: availabilityColor,
            border: `1px solid ${availabilityBorder}`,
          }}
        />
      )}
      
      {/* Content */}
      {children}
    </div>
  );
};

export default CalendarTimeSlot;